<section>
  @if (label && label !='') {
    <div id="termlength" class="active">
      <mat-label aria-label="{{ displayLabel | translate }}">{{ displayLabel | translate }}**</mat-label>
    </div>
  }
  <mat-button-toggle-group [name]="groupName">
    @for (option of options2; track option; let i = $index) {
      <mat-button-toggle id="toggleButton{{i}}" [value]="option.value">
        {{ option.label }}
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
</section>
